<div class="app-container">
  <div class="main-content">
    <router-outlet />
  </div>
</div>
